import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { ReportLink } from "../shared/SectionCard";
import {
  STATIC_END_CUSTOMER_LAUNCHES,
  STATIC_END_CUSTOMER_LAUNCHES_DISABLED,
} from "../../data/actionItemsConfig";

type EndCustomerLaunchesSectionProps = {
  isStaticDisabled?: boolean;
};

const GrowthBadge: React.FC<{ label: string }> = ({ label }) => (
  <span className="admin-home-launches__growth-badge">
    <Iconography icon="arrowTrendUp" size={IconographySizes.Small} />
    {label}
  </span>
);

const DetailList: React.FC<{
  details: { label: string; value: string }[];
}> = ({ details }) => (
  <ul className="admin-home-launches__tile-details">
    {details.map((detail) => (
      <li key={detail.label}>
        <span>{detail.label}</span>
        <strong>{detail.value}</strong>
      </li>
    ))}
  </ul>
);

const EndCustomerLaunchesSection: React.FC<EndCustomerLaunchesSectionProps> = ({
  isStaticDisabled = STATIC_END_CUSTOMER_LAUNCHES_DISABLED,
}) => {
  return (
    <section
      className={`admin-home-launches${
        isStaticDisabled ? " admin-home-launches--static-disabled" : ""
      }`}
    >
      <div className="admin-home-launches__header">
        <div className="admin-home-launches__title-block">
          <span className="admin-home-launches__header-icon" aria-hidden>
            <Iconography icon="globe" size={IconographySizes.Small} />
          </span>
          <div className="admin-home-launches__header-text">
            <h3 className="admin-home-launches__title">End Customer Launches</h3>
            <p className="admin-home-launches__subtitle">
              Global adoption &amp; usage metrics
            </p>
          </div>
        </div>
        {!isStaticDisabled ? (
          <span className="admin-home-launches__trend-badge">
            <Iconography icon="arrowTrendUp" size={IconographySizes.Small} />
            Strong Growth Trend
          </span>
        ) : null}
      </div>

      <div className="admin-home-launches__grid">
        {STATIC_END_CUSTOMER_LAUNCHES.map((metric) => (
          <article key={metric.id} className="admin-home-launches__tile">
            <div className="admin-home-launches__tile-top">
              <span className="admin-home-launches__tile-title">
                {metric.title}
              </span>
              <span className="admin-home-launches__tile-subtitle">
                {metric.subtitle}
              </span>
              <div className="admin-home-launches__tile-value-row">
                <span className="admin-home-launches__tile-value">
                  {metric.value}
                </span>
                {metric.yoyGrowth && (
                  <GrowthBadge label={metric.yoyGrowth} />
                )}
              </div>
            </div>

            {/* Middle: Jan/Feb only on Organizations; keeps Net Launches in the shared bottom row */}
            <div className="admin-home-launches__tile-middle">
              {metric.footer ? <DetailList details={metric.details} /> : null}
            </div>

            <div className="admin-home-launches__tile-bottom">
              {metric.footer ? (
                <div className="admin-home-launches__tile-footer">
                  <span className="admin-home-launches__tile-footer-label">
                    {metric.footer.label}
                  </span>
                  <div className="admin-home-launches__tile-footer-value-row">
                    <strong>{metric.footer.value}</strong>
                    {metric.footer.yoyGrowth && (
                      <GrowthBadge label={metric.footer.yoyGrowth} />
                    )}
                  </div>
                </div>
              ) : (
                <DetailList details={metric.details} />
              )}
            </div>
          </article>
        ))}
      </div>

      <div className="admin-home-launches__footer">
        <ReportLink label="View End Customer Launch Report" />
      </div>
    </section>
  );
};

export default EndCustomerLaunchesSection;
